import 'bootstrap/dist/css/bootstrap-grid.min.css';
import '../css/fonts/icomoon/style.css';
import '../css/main.scss';

window.onload = function(){
    startHomeAnimation();
}

let startHomeAnimation = function(){
    // setTimeout(function(){
        document.querySelector('.v-text').classList.remove('v-text--initial');
        document.querySelector('.v-cover__text').classList.remove('v-cover__text--initial');
    // }, 3000);
    setTimeout(() => {
        startTyping('.v-intro');
    }, 1000);
    setTimeout(() => {
        document.querySelector('.v-text .button').style.opacity="1";
        document.querySelector('main').classList.remove('letItLoad');
    }, 6500);
}

let startTyping = function(target){
    let intro = document.querySelector(target);
    let text = intro.innerHTML;
    let str = '';
    intro.classList.remove('v-intro--hide');
    intro.innerHTML = str;

    let i=0;
    let typing = setInterval(function(){
        str += text[i];
        intro.innerHTML = str;
        i++;
        if(i >= text.length){
            clearInterval(typing);
        }
    },80);
}

let readMore = document.querySelectorAll('.v-truncatable');
readMore.forEach(target => {
    target.addEventListener('click', function(){
        console.log(target.closest('.v-truncatable').classList.toggle('v-truncate'));
    });
});